import axios from 'axios'
import i18n from '../locale/i18n'
import { getAuthorization, getBossToken, setAuthorization } from '../util/userInfo' // eslint-disable-line

let baseUrl = ''
let flag = window.localStorage.getItem('mock') === 'true' // mock

if (process.env.NODE_ENV === 'production') {
  // 测试部使用的生产环境，上线时改为发布环境
  baseUrl = '/'
} else {
  // mock 启动本地mock服务端口npm run mock
  // baseUrl = '/mock'

  // 开发环境
  // baseUrl='/develop'

  // UAT
  // baseUrl='/uat'

  // edas
  // baseUrl = '/edas'
  // edas-pro
  baseUrl = '/dev'
  setAuthorization('aa25a98e-719f-46fc-befe-42024c2e8ca1')
  // setAuthorization('020d1d26-c923-4d3a-8cbd-f8d589fe0b8b')
}

let get
if (flag) {
  get = 'get11/'
} else {
  get = ''
  axios.defaults.baseURL = baseUrl
}
export const urls = {
  baseUrl: baseUrl,
  UPLOAD_IMAGE: `/pafs/rest/uploadservices/uploadbynewimagetype_new`,

  // 用户信息
  USER_INFO: 'eas/user',
  DETECTION_404Page: 'ad/404detection',

  // 抽奖记录
  REWARD_HISTORY: 'eas/activity/history/list',

  // 点击量统计
  CLICK_RATE: 'ad/clickRate-Web',
  GET_BARCODE: 'eas/pub/pic/barcode',

  // 目的地
  GET_DESTINATION: 'poi/travel/destination',
  GET_SHOP_LIST: 'poi/travel/floor/all',
  GET_SHOP_DETAIL: 'poi/travel/poi/detail',
  GET_fujin: 'poi/travel/distance/poi',

  // cbd
  POST_CBD: 'poi/travel/cbd',

  // 天气
  GET_WEATHER: 'eas/tools/weather',

  // 文案
  GET_WORDS: `${get}words/query`,

  // 黄页
  GET_YELLOW_MENU: `${get}yellow-page/menu`,
  GET_YELLOW_SERVICE: `${get}yellow-page/service-list`,
  GET_YELLOW_SEARCH: `${get}yellow-page/search`,
  GET_YELLOW_DETAIL: `${get}yellow-page/detail`,

  // 天气
  GET_ALL_CITY: `${get}eas/tools/weather/list/destination`,
  GET_SEARCH_CITY: `${get}eas/tools/weather/destination`,
  GET_WUYOU_WEATHER: `${get}eas/provider/source/weather`,

  // 视频播放
  GET_VIDEO_BY_ID: `${get}video/getVideoInfoById`,
  SEND_VIDEO_USER_ID: `${get}eas/none/sign/shareQuest`,

  GET_NEWS: `${get}news/getNewsListByPage`,
  GET_NEWS_DETAIL: `${get}news/get-by-id`,

  // 漫游专区
  GET_ZOAM_DESTINATION: `${get}zoam/destination/home`,
  GET_ZOAM_DETAIL: `${get}zoam/product/detail`,
  GET_ZOAM_APPLY: `${get}zoam/product/apply/now`,
  GET_ZOAM_SUBMIT: `${get}zoam/product/apply/submit`,
  GET_ZOAM_TAB: `${get}zoam/destination/charge/tab`,
  GET_ZOAM_TAB_DETAIL: `${get}zoam/destination/charge/tab/detail`,
  GET_ZOAM_FREEDOM: `${get}zoam/product/freedom`,
  GET_MYZOAM: `${get}zoam/product/apply/currentvas`,

  // 鉴权（伟华）
  // GET_TOKEN: `eas/test/token`,
  // http://git.komect.net/wlan/eas/wikis/oauth#17-%E6%9F%A5%E8%AF%A2boss%E4%BF%A1%E6%81%AF
  GET_TOKEN: `eas/test/pub/token`,
  GET_BOSS: `${get}eas/boss`,

  // 中信保险
  GET_ZHONGXIN: `${get}zoam/citic/query`,

  // 积分
  GET_GRADE_RECORDS: 'eas/user/integral_details',
  // 个人中心
  GET_USER_CENTER: 'eas/user/center',
  USER_SIGN_IN: 'eas/sign/sign_in',
  USER_UNREAD: 'user/integral/unread',
  // 优惠专区
  GET_AD_LIST: 'ad/couponArea/getAdListByPage',
  GET_AD_DETAIL: 'ad/couponArea/getDetailById',
  RECEIVED: 'ad/couponArea/receive',
  SEND_CODE: 'ad/couponArea/sendCode',
  GET_AD_TYPE: 'ad/couponArea/getStoreTypeList',
  GET_BRANCH_STORE_LIST: 'ad/couponArea/getBranchStoreList',

  // 龙虎榜
  GET_FEE_SHOP: 'ad/rankingList/rank/app',
  GET_FEE_STAFF: 'ad/rankingList/rank/fee',

  // 行山
  GET_LEADERBOARD_USRER: 'eas/walk/record',
  GET_LEADERBOARD_LIST: 'eas/walk/list',
  GET_ACTIVITY_LIST: 'eas/activity/list',
  GET_TOPBANNER: 'walk/headcount',
  POST_WALK_AUTH: 'eas/user/extra',
  GET_EXAMINE: 'examine/get-examine',
  ADD_EXAMINE: 'examine/add-examine',
  CHECK_BLACK: 'examine/check-black',
  GET_EXAMINE_HISTORY: 'examine/get-examine-history',

  // 邀请好友
  GET_INVITE_CODE: 'eas/invite/createInviteCode',
  GET_COUNT_BY_USERID: 'eas/invite/getCountByUserId',
  GET_INFO_BY_USERID: 'eas/invite/getInfoByUserId',
  SEND_INVITE_CODE: 'eas/invite/pub/sendCode',
  RECEIVE_REWARD: 'eas/invite/pub/receiveReward',
  RECORD_COUNT: 'eas/invite/pub/recordCount',
  SOCIAL_INVITE: 'eas/invite/pub/socialInvite',

  // 邀请好友（new）
  GET_INVITE_CODE_NEW: 'eas/invite/new/getInviteCode',
  CONFIRM_INVITE_CODE: 'eas/invite/new/confirmInviteCode',
  GET_AD_LIST_NEW: 'ad/getAdListByPage',
  GET_INVITE_LIST: 'eas/invite/new/getInviteRecord',

  // 积分兑换
  GET_GOODS_LIST: 'business_alliance/redeem/getGoodsByUserId',
  GET_GOODS_TYPE: 'business_alliance/redeem/getSortedGoodInfo',
  GET_GOODS_DETAIL: 'business_alliance/redeem/getGoodsDetailById',
  USERGOOD_STATISTIC: 'business_alliance/redeem/userGoodsStatistic',
  GET_GOODS_BY_USERID: 'eas/redeem/getGoodsByUserId',
  GET_RECORD_BY_USERID: 'eas/redeem/getRecordByUserId',
  GET_VERIFY_CODE: 'eas/redeem/setVerifyCode',
  CHECK_VERIFY_CODE: 'eas/redeem/checkVerifyCode',
  REDEEM_GOODS: 'eas/redeem',
  GET_ADDRESS_BY_GOODSTYPE: 'eas/redeem/getAddressByGoodsType',
  IS_ALLOW_REDEEM: 'eas/isRedeemAllowed',
  EXPIRE_SCORE_TOTAL: 'user/integral/total',
  INTEGRAL_DETAILS_TYPE: 'user/integral/details',
  GET_USER_PHONE: 'eas/user/getUserPhone',
  GET_PHONE_CODE: 'eas/redeem/setVerifyCode',
  CHECK_PHONE_CODE: 'eas/redeem/checkVerifyCode',
  GET_CODE_CHANGE_DETAIL: 'eas/redeem/redeemCodeList',
  REDEEM_COUPON: 'business_alliance/redeem/coupon/redeem',

  // 商盟
  GET_CITY_TYPE: 'business_alliance/redeem/coupon/region',
  GET_COUPEN_TYPE: 'business_alliance/redeem/coupon/type',
  GET_MERCHANT_GOODS: 'business_alliance/redeem/coupon/activity',
  GET_MERCHANT_INTER_GOODS: 'business_alliance/redeem/coupon/externalGoods',

  // 万分精彩
  GET_MERCHANT_GOODS_LIST: 'business_alliance/wonderful/getEffectiveGoods',
  GET_MERCHANT_INTER_TASK: 'business_alliance/wonderful/getEffectiveTasks',

  //任务中心打卡
  GET_INTEGRAL_DATA: 'eas/sign/detail',
  GET_INTEGRAL_STATUS: 'eas/sign/reminderSwitch',

  // 积分商城
  GET_INTEGRAL_ORDERLIST: 'business_alliance/order/list',
  GET_INTEGRAL_ORDERDETAIL: 'business_alliance/order',
  GET_INTEGRAL_LOGISTICS: 'business_alliance/order/redeem/logisticsDetail',
  GET_INTEGRAL_BANNER: 'business_alliance/redeem/ad-banner ',
  GET_SORTED_GOODSINFO: 'business_alliance/redeem/getSortedGoodInfo',
  GET_USERINTEGRAL_CARD: 'user/integral/card ',
  GET_USERINTEGRAL_RECORD: 'user/integral/all-details',
  INTEGRAL_CANCLE_ORDER: 'business_alliance/order/cancel',
  PAY_FOR_GOODS: 'business_alliance/redeem',
  // 门市取货
  OUTLET_PLACE_LIST: 'business_alliance/outlet/findOutlets',
  OUTLET_RECEIVER_GET: 'business_alliance/outlet/receiver/get',
  OUTLET_RECEIVER_UPDATE: 'business_alliance/outlet/receiver/update',
  // 智能柜取货CAB
  CAB_LIST: 'business_alliance/locker/lockerList',
  CAB_AREA_LIST: 'business_alliance/locker/lockerAreaAndDistrict',
  // 版本更新
  UPDATE_BY_ID: 'version/getVerisonById',
  UPDATE_PLATEFOEM: 'version/findByPlatform',

  // 版本更新最新版
  UPDATE_PLATEFOEM_LATEST: 'version/findByPlatformHz',

  // 节气打卡
  CAN_PUNCH: 'eas/activity/solarTermsHiking/canPunch',
  PUNCH_LIST: 'eas/activity/solarTermsHiking/getAllPunchInfo',

  // 登陆送积分
  LOGIN_INTEGRAL: 'eas/walk/activity/spring/user/loginIntegral',

  // 地址管理
  GET_ADDR_ALL: 'user/shippingAddress/all',
  GET_ADDR_RECENT: 'user/shippingAddress/recent',
  GET_ADDR_BY_ID: 'user/shippingAddress',
  ADD_ADDR: 'user/shippingAddress/create',
  EDIT_ADDR: 'user/shippingAddress/update',
  GET_AREA_LIST: 'user/shippingAddress/area',
  EDIT_ADDR_RECENT: 'user/shippingAddress/recent/update',
  DELETE_ADDR: 'user/shippingAddress/delete',

  // 问题反馈
  SOLUTION_ADD: 'user/userFeedback/none/create',
  GET_SOLUTION_LIST: 'user/userFeedback/none/optionLists',

  // 新版UI-积分
  BUSINESS_ORDER_CREATE: 'business_alliance/order/createAndRedeem',
  BUSINESS_ORDER: 'business_alliance/order/createOrder',
  BUSINESS_ORDER_END: '/v1/api/business_alliance/order/orderInfoV2',
  BUSINESS_ORDER_REDEEM: '/v1/api/business_alliance/order/update',
  CODE_DETAIL: 'business_alliance/redeem/codeDetail',
  CODE_DETAIL_HK: 'user/ticketBag/epassDetail',
  GET_CODE_STATUS: 'business_alliance/redeem/getBaiJiaCodeStatus',
  REFRESH_CODE: 'business_alliance/redeem/refreshBaiJiaCode',

  // 优惠专区
  GET_COUPON_BANNERS: 'ad/couponArea/getCouponAreaBannerList',
  GET_COUPON_DETAIL: 'ad/couponArea/getCouponAreaAdItemDetail',
  GET_COUPON_LIST: 'ad/couponArea/getCouponAreaAdItemList',
  RECEIVE_ALLOWED: 'ad/couponArea/isReceiveAllowed',
  USE_COUPON: 'ad/couponArea/use',
  RECEIVE_COUPON: 'ad/couponArea/receive',

  // 优越会员
  GET_privilege_LIST: 'user/privilege/all',
  GET_privilege_ADS: 'user/privilege/banner'

}

// 不需要token的接口
// export const noTokenUrls = [
//    urls.PUBLIC_RESET_PASSWD,
//    urls.PUBLIC_REGISTER,
//    urls.PUBLIC_LOGIN,
//    urls.PUBLIC_CAPTCHA_IMG,
//    urls.PUBLIC_CAPTCHA_SMS,
//    urls.PUBLIC_CHECK_ACCOUNT,
//    '/' // 根(登录)
// ]

// 不需要登录的路由
// export const noLoginUrls = [
//    '/',
//    '/login/regist',
//    '/login/forgetpasswd',
//    '/updating'
// ]

let a = getAuthorization()
let b = getBossToken()

axios.defaults.headers.common['X-UserAgent'] = 'hshhk/h5/7'
axios.defaults.headers.common['Accept-Language'] = (i18n.locale === 'sc' ? 'zh-CN' : (i18n.locale === 'tc' ? 'zh-TW' : 'en-US'))
a && (axios.defaults.headers.common['Authorization'] = a)
b && (axios.defaults.headers.common['BossToken'] = b)
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 40000
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'

// ajax请求
// Vue.prototype.axios = axios



// WEBPACK FOOTER //
// ./src/util/urls.js